import { Component } from 'react'
import PropTypes from 'prop-types'
import Link from '../../../Utilities/Link'
import ProgrammableLink from '../../../Utilities/ProgrammableLink'
import { Container, H2, H4, Subtitle1, Body1, Share, Button } from '../../../cdl-react-components/components'
import { formatFileLink } from '../../../cdl-react-components/utilities/files'
import { formatBytes } from '../../../cdl-react-components/utilities/files'
import { formatResultsItemDate } from '../../../../utilities'

class ActivityMapMobile extends Component {
    renderDownloadButton = (activityMap, authenticated, user) => {
        if (!activityMap.pdf)
            return null
        else if (new Date(activityMap.publication_date) > new Date())
            return null
        else if (authenticated)
        return (
            <ProgrammableLink 
                style={{ width: '100%' }}
                href={this.props.link}
                target="_blank" rel="noreferrer"
                onBeforeRedirect={this.props.logMapOpened}>
                <Button raised style={{ width: '100%' }}>Download Map</Button>
            </ProgrammableLink>
        )
        else if (activityMap.sample_pdf)
            return <Link className="btn btn--raised" href={this.props.sampleLink}>Download Map</Link>
        else if (user)
            return <Link className="btn btn--raised" href="/subscribe">Subscribe to Download Map</Link>
        else
            return (
                // <Fragment>
                //     <Link className="btn" href="/subscribe">Subscribe</Link>
                    <Button raised onClick={this.props.handleLogin}>Login to View Map</Button>
                // </Fragment>
            )
    }

    renderContents = activityMap => {
        return (
            <div className="activity-map__contents">
                <H4>Contents</H4>
                <table>
                    <tbody>
                        {activityMap.pdf && (
                            <tr>
                                <th>File&nbsp;size:</th>
                                <td>{activityMap.pdf_size_field ? formatBytes(activityMap.pdf_size_field, 2) : null}</td>
                            </tr>
                        )}
                        <tr>
                            <th>Dimensions:</th>
                            <td>36" X 72"</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        const { activityMap, authenticated, user } = this.props

        return (
            <div id="activity-map--mobile">
                { activityMap.cover_image && (
                    <div className="activity-map__image">
                        <img alt={activityMap.title} src={formatFileLink(activityMap.cover_image)} />
                    </div>
                )}
                <Container>
                    <H2>{activityMap.title}</H2>
                    <Subtitle1>{activityMap.subtitle}</Subtitle1>
                    <Body1>{formatResultsItemDate(activityMap)}</Body1>
                    <Body1 dangerouslySetInnerHTML={{ __html: activityMap.description }} />
                    <div className="flex flex--center">
                        {this.renderDownloadButton(activityMap, authenticated, user)}
                    </div>
                    <hr />
                    {this.renderContents(activityMap)}
                    <hr />                    
                    <Share title={activityMap.title} url={window.location.origin + window.location.pathname} />
                </Container>
            </div>
        )
    }
}

ActivityMapMobile.propTypes = {
    activityMap: PropTypes.object.isRequired,
    authenticated: PropTypes.bool.isRequired,
    handleLogin: PropTypes.func.isRequired,
    user: PropTypes.object,
    link: PropTypes.string,
    sampleLink: PropTypes.string
}

export default ActivityMapMobile